<template>
  <article class="user_view">
    <left-menu/>

    <section class="user_view__header" style="display: flex;">
      <div style="width: 50%;">
        <div class="user_view__header--info"> 
          <div>
            <h1>Urgentes</h1>
            <h4>Listado de audios urgentes por cliente</h4>
          </div>
        </div>
        <info-client style="margin-top:10px;width:100%;margin-left-6%;margin-top:20px"></info-client>
      </div>
      <div style="margin-left: 70px; width: 50%;">
        <div class="user_view__header--info"> 
          <div>
            <h1>Urgentes</h1>
            <h4>Listado de alertas urgentes por cliente</h4>
          </div>
        </div>
        <info-alerts-client style="margin-top:10px;width:100%;margin-left-10%;margin-top:20px"></info-alerts-client>
      </div>

      
      <!-- <div class="user_view__header--sec1">
        <button  class="secondary_button" :class="{'click':isUpdate, 'active': !isUpdate}" @click="toUpdate" >ACTUALIZAR</button>
        <button v-if="isAdmin" class="primary_button" @click="$router.push({ name: 'CreateClient' })" >CREAR</button>
      </div> -->



      
      <!-- <section v-else-if="photos.length>0" class="modal_resource_list__body_content--photo">
        <div class="audio_menu__container--list_photo">
          <div  v-for="(photo,i) in photos" :key="i" :id="'photoref'+i" class="audio_menu__audio-item--photo" :style="i%2==0?'':'margin-left: 20px;'">
            <img style="width:100%; height:84px;border-radius:6px 0px 0px 0px" :src="photo">    
            <div>
                <h4 class="audio_menu__audio-item__name">Foto {{i+1}}</h4>
                <div class="modal_resource_list__little_bar--img" :style="'background-color:'+color"></div>
            </div>    
            
          </div>
        </div> 
      </section> -->
    </section> 
  </article>
</template>

<script>
import ClientTable from './../shared/ClientTable';
import ClientAlertsTable from './../shared/ClientAlertsTable';
export default {
  data(){
    return{
    }
  },
  components:{
    'info-client':ClientTable,
    'info-alerts-client': ClientAlertsTable 
  },
  
  methods:{
    
  },
  created(){
   
  },

  
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Urgents.vue